import { useState } from 'react';
import {
  Box,
  Drawer,
  IconButton,
  Typography,
  useMediaQuery,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { MOBILE_MAX_WIDTH_PX } from 'src/constants/Layout';
import MarkdownRenderer from 'src/components/markdown-renderer/MarkdownRenderer';

interface InfoDrawerTriggerProps {
  title: string;
  markdownContent: string;
  ariaLabel?: string;
  iconButtonId?: string;
}

const InfoDrawerTrigger: React.FC<InfoDrawerTriggerProps> = ({
  title,
  markdownContent,
  ariaLabel,
  iconButtonId,
}) => {
  const [open, setOpen] = useState(false);
  const isMobile = useMediaQuery(`(max-width:${MOBILE_MAX_WIDTH_PX}px)`);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton
        id={iconButtonId}
        size="small"
        aria-label={ariaLabel ?? title}
        onClick={handleOpen}
      >
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
      <Drawer
        anchor={isMobile ? 'bottom' : 'right'}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            display: 'flex',
            flexDirection: 'column',
            width: isMobile ? '100%' : 480,
            maxWidth: '100%',
            height: isMobile ? 'min(75vh, 720px)' : '100%',
            padding: 3,
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
            marginBottom: 2,
          }}
        >
          <Typography variant="h6">{title}</Typography>
          <IconButton
            edge="end"
            aria-label={`Close ${title}`}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            paddingRight: isMobile ? 0 : 1,
          }}
        >
          <MarkdownRenderer content={markdownContent} color="text.primary" />
        </Box>
      </Drawer>
    </>
  );
};

export default InfoDrawerTrigger;
